
import { defineComponent, ref } from "vue"
import { spatialOmicsApi } from "@/request";
import GeneColorViewPlot from "@/components/GeneColorViewPlot.vue";
import { ElMessageBox } from 'element-plus'

export default defineComponent({
  components: {
    GeneColorViewPlot
  },
  data() {
    return {
      analysisGeneList: [],
      selectedGeneFeatureList : []
    }
  },
  setup() {
    let selectedGeneFeatureR = ref('')
    let selectedGeneTypeR = ''
    let geneFeatureListR = ref([])
    let useLogR = ref(false)
    let logableR = ref(true)
    let selectedGeneFeatureG = ref('')
    let selectedGeneTypeG = ''
    let geneFeatureListG = ref([])
    let useLogG = ref(false)
    let logableG = ref(true)
    let selectedGeneFeatureB = ref('')
    let selectedGeneTypeB = ''
    let geneFeatureListB = ref([])
    let useLogB = ref(false)
    let logableB = ref(true)
    let markerSize = ref(2)
    let markerSizeList = ref([1,2,3,4,5,6,7,8,9,10])
    let dataId = -1
    const colorPlot: any = ref(null)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let geneFeatureAllList = []

    /**
     * 获取当前的data id
     */
    const getDataId = () => {
      return dataId
    }

    /**
     * 设置数据
     * @param data data数据
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const setData = (data) => {
      dataId = data.id

      let featureList = data['feature_list']

      let geneList = featureList['gene'].map((value: string) => ({
        value: `${value}*gene`,
        label: value,
      }))
      let obsList = featureList['obs'].map((value: string) => ({
        value: `${value}*obs`,
        label: value,
      }))
      let obsmList = featureList['obsm'].map((value: string) => ({
        value: `${value}*obsm`,
        label: value,
      }))
      console.log(geneList, obsList, obsmList)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      geneFeatureListR.value = [...geneList, ...obsList, ...obsmList]
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      geneFeatureListG.value = [...geneList, ...obsList, ...obsmList]
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      geneFeatureListB.value = [...geneList, ...obsList, ...obsmList]
      if('obsm' in featureList && Object.values(featureList['obsm']).includes('X_umap@0') && Object.values(featureList['obsm']).includes('X_umap@1') && Object.values(featureList['obsm']).includes('X_umap@2')){
        selectedGeneFeatureR.value = "X_umap@0"
        selectedGeneFeatureG.value = "X_umap@1"
        selectedGeneFeatureB.value = "X_umap@2"
        selectedGeneTypeR = 'obsm'
        selectedGeneTypeG = 'obsm'
        selectedGeneTypeB = 'obsm'
      }else if('obsm' in featureList && Object.values(featureList['obsm']).includes('X_pca@0') && Object.values(featureList['obsm']).includes('X_pca@1') && Object.values(featureList['obsm']).includes('X_pca@2')){
        selectedGeneFeatureR.value = "X_pca@0"
        selectedGeneFeatureG.value = "X_pca@1"
        selectedGeneFeatureB.value = "X_pca@2"
        selectedGeneTypeR = 'obsm'
        selectedGeneTypeG = 'obsm'
        selectedGeneTypeB = 'obsm'
      }else{
        selectedGeneFeatureR.value = featureList['gene'][0]
        selectedGeneFeatureG.value = featureList['gene'][0]
        selectedGeneFeatureB.value = featureList['gene'][0]
        selectedGeneTypeR = 'gene'
        selectedGeneTypeG = 'gene'
        selectedGeneTypeB = 'gene'
      }
      geneFeatureAllList = [...geneList, ...obsList, ...obsmList]
    }

    /**
     * 散点图点大小改变的回调函数
     */
    const markerSizeChangeCallback = () => {
      console.log(markerSize)
      colorPlot.value.changeMarkerSize(markerSize.value)
    }

    /**
     * 根据选择的基因获取当前选择的三个基因的相关数据，并更新相关的图
     * @param item R或者G或者B下拉菜单当前选择的基因
     * @param flag R或者G或者B
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const geneFeatureChangeCallBack = (item, flag: string) => {
      console.log(item, flag)
      if (flag === 'R') {
        selectedGeneFeatureR.value = item.split('*')[0]
        selectedGeneTypeR = item.split('*')[1]
      } else if (flag === 'G') {
        selectedGeneFeatureG.value = item.split('*')[0]
        selectedGeneTypeG = item.split('*')[1]
      } else if (flag === 'B') {
        selectedGeneFeatureB.value = item.split('*')[0]
        selectedGeneTypeB = item.split('*')[1]
      }
      getGeneColorViewData()
    }

    /**
     * R选项基因的filter函数
     * @param query 查询字符串
     */
    const geneFeatureFilterR = (query: string) => {
      console.log(query)
      if (query !== '') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListR.value = geneFeatureAllList.filter((item: any) => {
          return item.label.toLowerCase().includes(query.toLowerCase())
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListR.value = geneFeatureAllList
      }
    }

    /**
     * G选项基因的filter函数
     * @param query 查询字符串
     */
    const geneFeatureFilterG = (query: string) => {
      console.log(query)
      if (query !== '') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListG.value = geneFeatureAllList.filter((item: any) => {
          return item.label.toLowerCase().includes(query.toLowerCase())
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListG.value = geneFeatureAllList
      }
    }

    /**
     * B选项基因的filter函数
     * @param query 查询字符串
     */
    const geneFeatureFilterB = (query: string) => {
      console.log(query)
      if (query !== '') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListB.value = geneFeatureAllList.filter((item: any) => {
          return item.label.toLowerCase().includes(query.toLowerCase())
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureListB.value = geneFeatureAllList
      }
    }

    /**
     * 设置某通道的基因是否需要log
     * @param item R或者G或者B是否需要log
     * @param flag R或者G或者B
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const logChangeCallback = (item, flag: string) => {
      console.log(item, flag)
      colorPlot.value.setLog(item, flag)
    }

    /**
     * 根据选择的三个基因获取相关的数据，并更新对应的图
     */
    const getGeneColorViewData = () => {
      console.log('selected: ', selectedGeneFeatureR.value, selectedGeneFeatureG.value, selectedGeneFeatureB.value)
      console.log('log:', useLogR.value, useLogG.value, useLogB.value)
      let geneInfo = {
        'data_id': dataId,
        'feature_name_r': selectedGeneFeatureR.value,
        'feature_type_r': selectedGeneTypeR,
        'feature_name_g': selectedGeneFeatureG.value,
        'feature_type_g': selectedGeneTypeG,
        'feature_name_b': selectedGeneFeatureB.value,
        'feature_type_b': selectedGeneTypeB,
      }
      console.log(geneInfo)
      spatialOmicsApi.getGeneColorView(geneInfo).then((res) => {
        console.log(res.data)
        logableR.value = res.data['logable_r']
        useLogR.value = logableR.value ? useLogR.value : false
        logableG.value = res.data['logable_g']
        useLogG.value = logableG.value ? useLogG.value : false
        logableB.value = res.data['logable_b']
        useLogB.value = logableB.value ? useLogB.value : false
        colorPlot.value.setPlotData(res.data['gene_color_plot'])
      })
    }


    return {
      selectedGeneFeatureR,
      selectedGeneFeatureG,
      selectedGeneFeatureB,
      geneFeatureListR,
      geneFeatureListG,
      geneFeatureListB,
      useLogR,
      useLogG,
      useLogB,
      logableR,
      logableG,
      logableB,
      markerSize,
      markerSizeList,
      colorPlot,
      getDataId,
      markerSizeChangeCallback,
      getGeneColorViewData,
      geneFeatureChangeCallBack,
      logChangeCallback,
      setData,
      geneFeatureFilterR,
      geneFeatureFilterG,
      geneFeatureFilterB,
    }
  },
  methods: {
    analysisFromSelected () {
          this.selectedGeneFeatureList = []
          this.analysisGeneList = []
          console.log('analysis')
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          console.log(this.$refs.colorPlot.getSelectedPointsIndex(), this.getDataId())

          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          if(this.$refs.colorPlot.getSelectedPointsIndex().length === 0){
            ElMessageBox.alert('Please select the region of interests first.', '', )
            return
          }
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          let data = {data_id : this.getDataId(), selectedPointsIndexList : this.$refs.colorPlot.getSelectedPointsIndex()}
          console.log(data)
          spatialOmicsApi.analyzeGeneColorView(data).then((res) => {
            console.log(res.data)
            console.log(this.analysisGeneList)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.analysisGeneList.push({id:"selection", rank:"", src:"data:image/png;base64,"+ res.data["selection"]})
            for(let i=0;i<res.data["topn"].length;i++){
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              this.analysisGeneList.push({id:res.data["topn"][i]["name"], rank:res.data["topn"][i]["rank"], src:"data:image/png;base64,"+ res.data["topn"][i]["image"]})
            }
            for(let i=0;i<this.analysisGeneList.length;i++){
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              this.selectedGeneFeatureList.push({label:this.analysisGeneList[i].rank.toString()+"-"+this.analysisGeneList[i].id, value:this.analysisGeneList[i].src})
              if(this.selectedGeneFeatureList.length > 5) break 
            }
            console.log(this.selectedGeneFeatureList)
          })
      }
  }
})

